<template>
  <div
    class="tripAdd"
    v-cloak
    style="background:#fff"
  >
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="back"
      class="khto"
    />
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
        style="height: 100%"
      >
        <div>
          <div class="hk-01">
            <ul>
              <li>
                <van-field
                  :label="$t('K130','出差人')"
                  required
                  is-link
                  readonly
                  :placeholder="$t('K130','出差人')"
                  v-model="params.ccr"
                  @click-right-icon="openEmpList('ccr')"
                  @click="openEmpList('ccr')"
                  input-align="right"
                />
              </li>
              <li>
                <van-field
                  :label="$t('所在部门')"
                  required
                  is-link
                  readonly
                  :placeholder="$t('K130','出差人')"
                  v-model="params.ccrPerson[0].deptName"
                  input-align="right"
                />
              </li>
            </ul>
            <ul
              v-for="(item,index) in apply.formList"
              :key="index"
              @click="add(item,index)"
              v-if="khlist"
            >
              <li>
                <van-field
                  :label="$t('K101','同行人员')"
                  :placeholder="$t('K101','同行人员')"
                  v-model="item.sxr"
                  is-link
                  readonly
                  @click-right-icon="openEmpList('sxr')"
                  @click="openEmpList('sxr')"
                  input-align="right"
                />
              </li>
              <li>
                <van-field
                  :label="$t('所在部门')"
                  required
                  is-link
                  readonly
                  :placeholder="$t('K130','出差人')"
                  input-align="right"
                  v-model="item.bm"
                />
              </li>
            </ul>
            <div @click="addDedution">
              <span class="add">
                <span class="itinerary"><img src="../../../images/home/jia.png">&nbsp;添加出差人</span>
              </span>
            </div>
          </div>
        </div>
        <div @click="khadd">
          <van-button
            round
            type="info"
            class="kh-button"
          >
            下一步
          </van-button>
        </div>
      </mescroll-vue>
    </div>
    <!--  -->
    <ld-tabbar v-if="false">
      <van-row
        type="flex"
        align="center"
        class="full-width bg-white shadow"
      >
        <van-col
          offset="7"
          span="8"
          class="pad-l-10"
        >
          <ld-button
            defaults
            size="md"
            @click="submit(1)"
          >
            {{ $t('B022','保存草稿') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          class="pad-l-10"
        >
          <ld-button
            main2
            size="md"
            @click="submit(2)"
          >
            {{ $t('K230','提交送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 日期 -->
    <ld-calendar
      ref="date"
      type="range"
      @selected="getDate"
      start-text="起"
      end-text="止"
    />

    <!-- 出差人 -->
    <ld-emp-list
      ref="empList"
      @selected="cxrCallBack"
      @radioSelected="ccrCallBack"
      :radio.sync="radio"
      :hide-person="params.ccrPerson"
    />

    <!-- c成本中心 科目码 -->
    <ld-check-list
      ref="checkList"
      @selected="checkCallBack"
    />
    <!--  -->
    <van-popup
      v-model="show"
      position="right"
      :style="{ height: '100%',width: '100%' }"
    >
      <router-view />
    </van-popup>
  </div>
</template>

<script >
import {Cell, Field, Switch, Icon, Tag, Toast,Button ,Popup,NavBar  } from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import { mapGetters } from 'vuex'
import ldEmpList from 'Components/ldEmpList/index.vue'
import ldCheckList from 'Components/ldCheckList'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getName, getEmpId } from 'Utils/publicFun'
import route from '../components/route'

import { changefocus } from 'Utils/tools'
import { queryParameter } from 'Utils/publicApi'

export default {
  name: 'TripAdd',
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Switch.name]:Switch,
    [Icon.name]:Icon,
    [Popup.name]:Popup ,
    [Tag.name]:Tag,
    [Toast.name]:Toast,
    [Button.name]:Button,
    [NavBar .name]:NavBar ,
    ldTabbar,
    ldButton,
    ldCheckList,
    ldEmpList,
    MescrollVue,
    route,
    ldCalendar: () => import('Common/ldCalendar'),
  },
  data: function() {
    return {
      show: false,
      khlist:false,
      index:'',
      radio:false,
      subjectCode:{
        show:false,
        must:false,
        write:false
      },
      // 定义动态添加的数据
      apply:{
        address:'',
        checkbox:false,
        // 定义动态添加的数据
        formList:[
          {
            sxr:'',
            bm:'',
          },
        ]
      },
    }
  },
  computed: {
    ...mapGetters({
      travelerList: 'trip/travelerList',
      params: 'trip/params',
      tkSearchInfo: 'tk/tkSearchInfo',
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      trSearchInfo: 'tr/trSearchInfo',
      htSearchInfo: 'ht/htSearchInfo',
      tk: 'trip/tk',
      tkInt: 'trip/tkInt',
      ht: 'trip/ht',
      tr: 'trip/tr',
      tripType: 'tripType',
      userInfo:'userInfo'
    }),
    zys : {//总价
      get(){
        return (Number(this.params.jtys) + Number(this.params.zsys) + Number(this.params.qtys)) || 0
      },
      // set方法只写下面这一行也是可以的
      set(){}
    },
    jtys () {
      let jtys = 0
      this.params.vipRoute.forEach(item => {
        if(item.proType!=10903){
          jtys += Number(item.fyys) * (item.cxrId ? item.cxrId.split(',').length : 1)
        }
      })
      return jtys
    },
    zsys () {
      let zsys = 0
      this.params.vipRoute.forEach(item => {
        if(item.proType==10903){
          zsys += Number(item.fyys)
        }
      })
      return zsys
    },
    ccsqdId () {//申请单详情 获取申请单ID
      return this.params.ccsqdId
    },
    title () {//标题
      if (this.ccsqdId) {
        return '修改出差申请单'
      } else {
        return '新增出差申请单'
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.tkSearchInfo.flights=[]
    this.$store.commit('tk/CLEAR_ALL',{})
    this.$store.commit('tkInt/CLEAR_ALL',{})
    this.$store.commit('ht/CLEAR_ALL',{})
    this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
    next()
  },
  activated () {
    this.params.zsys = this.zsys
    this.params.jtys = this.jtys
  },
  created () {
    if (this.ccsqdId) {//获取草稿申请单详情
      this.getInfo()
    } else {
      this.init()
    }
  },
  methods: {
    changefocus,
    init () {
      this.params.zsys = this.zsys
      this.params.jtys = this.jtys

      //默认当前人为出差人
      this.userInfo.empInfo.checked=true
      this.userInfo.empInfo.clkFlag=2
      this.params.ccrPerson=[this.userInfo.empInfo]
      this.params.ccr=getName(this.userInfo.empInfo)
      this.params.ccrId = getEmpId(this.userInfo.empInfo)
      this.$store.commit('trip/travelerList', this.params.ccrPerson)

      this.needApproval()//获取默认审批规则
      this.defaultCostCenter()//获取默认的成本中心
      this.getDefaultSpgz()

      //20012 科目码是否显示
      //20013 科目码是否必填
      //20014 科目码是否支持手输
      queryParameter('20012,20013,20014').then(arr => {
        if(arr&&arr.length){
          arr.forEach(item=>{
            if(item.paramNo==20012){
              this.subjectCode.show=(item.value1==1)
            }else if(item.paramNo==20013){
              this.subjectCode.must=(item.value1==1)
            }else if(item.paramNo==20014){
              this.subjectCode.write=(item.value1==1)
            }
          })
        }
      })
    },
    // 增加
    addDedution(){
      if(this.apply.formList.length == 1
      ){
        this.$toast('暂不支持更多的行程')
      }
      let statusType = true
      this.apply.formList.forEach((item) => {
        if (
          item.sxr == '' ||
          item.bm == ''
        ){
          statusType = false
        }
      })
      this.khlist = true
      if (statusType) {
        this.apply.formList.push({
          sxr:'',
          bm:'',
        })
      }
    },
    getDefaultSpgz(){
      this.$api['approval/matchGz']({
        projectId:this.params.projectId,
        empId:this.params.ccrId,
        deptId:'',
        cplx:''
      }).then(res=>{
        var cache=res.data||{}
        if(cache.gzid){
          this.params.appId=cache.gzid
          this.params.gzmc=cache.gzmc +'('+cache.gzdm+')'
        }
      })
    },
    //获取出差申请单详情
    getInfo () {
      this.$api['common/vipCcsqdGetInfo']({ ccsqdId: this.ccsqdId }).then(res => {
        let cache = res.data || {}
        cache.vipPerson=cache.personList
        this.tk.route = []
        let self = this
        let routeArr=[]
        if (cache.allRouteList && cache.allRouteList.length > 0) {
          cache.allRouteList.forEach(item=>{
            item.forEach(el=>{
              routeArr.push(el)
              if (el.proType == 10901) {
                self.tk.route.push(el)
              } else if (el.proType == 10902) {
                self.tkInt.route.push(el)
              } else if (el.proType == 10903) {
                self.ht.route.push(el)
              } else if (el.proType == 10904) {
                self.tr.route.push(el)
              }
            })
          })
        }
        cache.vipRoute=routeArr
        cache.project=cache.project == '0' ? false : true
        cache.ccrPerson=[cache.vipPerson.find(v => v.sxr == 0) || this.userInfo.empInfo]
        this.$store.commit('trip/travelerList', cache.ccrPerson)
        delete cache.personList
        delete cache.allRouteList
        this.$store.commit('trip/params', cache)
        this.needApprovalName()
      })
    },
    //保存草稿  submit   num = 1;    //提交送审   num = 2
    submit (num) {
      if(!this.params.ccr){
        this.$toast('请选择出差人')
        return
      }
      if(!this.params.mdd){
        this.$toast('请输入目的地')
        return
      }
      if(!this.params.costCenterId){
        this.$toast('请选择成本中心')
        return
      }
      if(!this.params.ccsy){
        this.$toast('请输入出差事由')
        return
      }
      if (!this.params.dateBegin || !this.params.dateEnd) {
        this.$toast('请选择出差日期')
        return
      }
      // 处理 出差人 和  随行人 ;
      let arr=[]
      this.params.vipPerson.forEach((item,index) => {
        item.xcxh= index
        arr.push({
          'cxrName': getName(item),
          // 'deptName': '',
          'empDeptid': item.deptId,
          'empId': item.empId,
          // 'empName': item.empName,
          // 'empNo': item.empNo,
          // 'empRank': item.empRank,
          // 'empRankName': '',
          'exPerson': item.clkFlag==2?0:1,//是否外来人员
          //'idNumber': item.idNumber,
          // 'passport': item.passport,
          // 'personId': '',
          // 'phoneNumber': item.phoneNumber,
          'sxr': item.sxr
        })
      })
      this.params.vipPerson = arr
      this.params.vipRoute.forEach((item, index)=> {
        item.xcxh = index
      })
      if(this.params.dateBegin >this.params.dateEnd){
        this.$toast('出差结束日期不可以小于开始日期')
      } else if(!this.params.gzmc) {
        this.$toast('请选择审批规则!')
      } else if(num == 2 && this.params.vipRoute.length < 1) {
        this.$dialog.confirm({
          title: this.$t('C474','提示'),
          message: '您未选择行程？是否提交送审'
        }).then(() => {
          // on confirm
          this.toApplyAjax(num)
        }).catch(() => {
          // on cancel
        })
      } else {
        this.toApplyAjax(num)
      }
    },
    //去提交申请 和 草稿  ajax
    toApplyAjax (num) {
      this.params.zys = this.zys
      this.params.addMethod = num
      this.params.project = this.params.project ? 1 : 0
      //删除的行程id
      //删除的出行人id
      let params = this.params
      params.vipRoute.forEach(o => {
        delete o.xh
      })

      this.$api['common/vipCcsqdAdd'](params).then(res => {
        let cache = res.data || {}
        if (!cache.ccsqdId) {
          this.$toast('送审失败')
          return
        }
        if(num == 1&&cache.ccsqdId) { // 保存草稿
          this.$dialog.alert({
            title: this.$t('C474','提示'),
            message: '保存草稿成功！'
          }).then(() => {
            this.toList()
          })
        }
        if (num == 2&&cache.ccsqdId) { // 提交送审   送审成功时，清除缓存
          this.$dialog.alert({
            title: this.$t('C474','提示'),
            message: '已送审！'
          }).then(() => {
            this.toList()
          })
        }
      })
    },
    //添加修改型行程
    addRoute (cplx) {
      if(!this.params.ccr){
        this.$toast('请选择出差人')
        return
      }
      if(!this.params.mdd){
        this.$toast('请输入目的地')
        return
      }
      if(!this.params.costCenterId){
        this.$toast('请选择成本中心')
        return
      }
      if(!this.params.ccsy){
        this.$toast('请输入出差事由')
        return
      }
      if (!this.params.dateBegin || !this.params.dateEnd) {
        this.$toast('请选择出差日期')
        return
      }
      let ccr = this.params.ccrPerson[0]
      ccr.sxr=0
      if(this.params.vipPerson.length>0){
        let bool = false
        this.params.vipPerson.forEach((item, index)=> {
          item.xcxh= index
          item.sxr = 1
          if(typeof(item.clkFlag)==='undefined'){
            if(item.personId&&(item.personId===ccr.personId)||item.empId&&(item.empId===ccr.empId)){
              bool=true
            }
          }else if(item.clkFlag==0||item.clkFlag==1){
            if(item.contactsId&&(item.contactsId===ccr.contactsId)){
              bool=true
            }
          }else if(item.clkFlag==2){
            if( item.empId&&(item.empId===ccr.empId)){
              bool=true
            }
          }
        })
        if(bool===false){
          this.params.vipPerson.push(ccr)
        }
      }else{
        this.params.vipPerson.push(ccr)
      }
      this.params.proType = cplx
      this.$router.push({path: '/tripRoute'})
    },
    clear () {
      this.$store.commit('trip/CLEAR_ALL')
      this.$store.commit('trip/CLEAR_PARAMS')
    },
    //删除行程
    deletRoute (index) {
      this.$dialog.confirm({
        title: this.$t('C474','提示'),
        message: '确定删除当前行程？'
      }).then(() => {
        this.params.vipRoute.splice(index,1)
        this.params.zsys=this.zsys
        this.params.jtys=this.jtys
      })
    },
    //出差人控件
    openEmpList(type){
      if (type=='ccr') {
        this.radio=true
        this.$store.commit('trip/travelerList',this.params.ccrPerson)
        this.$refs.empList.toggle({ index: 1, showTabIndex: [1] })
      } else if (type=='sxr') {
        if(this.params.ccrPerson.length==0){
          this.$toast('请先选择出差人')
          return
        }
        this.radio=false
        this.$store.commit('trip/travelerList',this.params.vipPerson)
        this.$refs.empList.toggle({ index: 0, showTabIndex: [0, 1, 2] })
        console.log('000',this.params.vipPerson)
      }
    },
    //出差人 回调
    ccrCallBack (emp) {
      this.params.ccr = getName(emp)
      this.params.ccrId = getEmpId(emp)
      this.params.ccrPerson=[emp]
      this.getDefaultSpgz()
    },
    khadd(){
      this.show = true
      this.$router.push('/khtripAdd/khxc')
    },
    add(item,index){
      console.log('点击回调',item,index)
      this.index = index
      console.log(this)
      if(this.index == 1){
        this.travelerList.forEach(item=>{
          item.checked = false
        })
      }
    },
    //同行人 回调
    cxrCallBack (list) {
      if (list) {
        let sxr=list.map(item=> {
          return getName(item)
        })
        let sxrId=list.map(item=> {
          return getEmpId(item)
        })
        this.params.sxr = sxr.join(',')
        this.params.sxrId = sxrId.join(',')
        this.params.vipPerson=list
        if(this.index == 0){
          this.apply.formList[0].sxr = this.params.sxr || ''
          var s = []
          var list = this.params.vipPerson.filter((item,index)=>{
            s.push(item.deptName)
          })
          var arr = [...new Set(s)]
          this.apply.formList[0].bm = arr+'' || ''
        }
        if(this.index == 1){
          this.apply.formList[1].sxr = this.params.sxr || ''
          var s = []
          var list = this.params.vipPerson.filter((item,index)=>{
            s.push(item.deptName)
          })
          var arr = [...new Set(s)]
          this.apply.formList[1].bm = arr+'' || ''
        }
      }
    },
    //项目 成本中心 科目码  审批规则 回调
    checkCallBack (info) {
      if (info.gzId) {
        info.appId=info.gzId
        info.gzmc=info.gzmc +'('+info.gzdm+')'
      }
      if (info.svalue) {
        this.params.subjectCode =info.svalue
      }
      if(info.projectName){
        this.getDefaultSpgz()
      }
      Object.assign(this.params, info)
      this.needApproval()
      this.defaultCostCenter()

    },
    showDate(){
      this.$refs.date.toggle({
        defaultDate:[this.params.dateBegin,this.params.dateEnd],
      })
    },
    //日期 回调
    getDate (date) {
      [this.params.dateBegin,this.params.dateEnd]=date
    },
    toggle (name, type) {
      // this.$store.commit('trip/CLEAR_TRAVELERlIST')
      this.$refs[name].toggle(type) // type : {radio:true|false} || 0 1 2 3
    },
    back () { //定向 返回列表
      this.$dialog.confirm({
        title:this.$t('C474','提示'),
        message: '您确认放弃本次操作'
      }).then(() => {
        this.toList()
      })
    },
    toList () {
      this.clear()
      this.$router.replace({path:'/khList'})
    },
    //获取到审批规则id (post)  获取默认的审批规则
    needApproval () {
      if (this.params.appId) return
      this.$api['approval/vipSpkzNeedApproval']({
        'bookEmpId': this.userInfo.empInfo.empId,
        'djlx': '11099',
        'ifViolate': '0',
        'projectId': this.params.projectId,
        'travelEmpIds': this.params.sxrId
      }).then((res) => {
        let cache = res.data || {}
        this.params.appId = cache.spgzId
        this.needApprovalName()
      })
    },
    //获取到审批规则名称(get)
    needApprovalName () {
      if (!this.params.appId) return false
      this.$api['approval/vipSpgzFindDetail']({
        gzid: this.params.appId
      }).then(res => {
        let cache = res.data || {}
        this.params.gzmc = cache.gzmc + '(' + cache.gzdm + ')'
      })
    },
    // 获取默认的成本中心
    defaultCostCenter () {
      if (this.params.costCenterId) return
      this.$api['common/costCenterFindList']({
        projectId: this.params.projectId,
        travelEmpd: this.params.ccrId,
        txEmpIds:this.params.sxrId
      }).then(res => {
        let cache = res.data || {}
        if (cache.defaultCostCenter) {
          Object.assign(this.params, cache.defaultCostCenter)
        } else if(cache.list){
          Object.assign(this.params, cache.list[0])
        }
      })
    }
  },

  watch: {
    'params.crr' (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
}
.pad-t-5{
    padding-top: 14px;
}
.pad-r-10{
    padding-right: 10px;
}
.pad-l-10{
    padding-left: 10px;
}
.pad-b-50{
  //padding-bottom: 100%;
}


/deep/ .van-nav-bar__content{
  background:#8282ab;
}
/deep/ .van-nav-bar__title{
  font-size:15px;
  color: #fff;
  font-weight: 300;
}
/deep/ .van-icon{
  //color: #fff ;
}
.hk-01{
  width: 100%;
  height: 635px;
  ul{

    li{
      border-width: 0px;
      position: relative;
      /* left: 2px; */
      top: 14px;
      /* width: 100%; */
      height: 50px;
      background: inherit;
      background-color: rgba(171, 171, 209, 0.2);
      border: none;
      border-radius: 5px;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-size: 12px;
      color: #656464;
      text-align: left;
      margin: 0px 10px 10px 10px;
    }
  }
}

/deep/ .van-cell{
  background-color: #fff0;
}
.add{
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.kh-button{
  width: 355px;
  height: 40px;
  background: linear-gradient(270deg, rgba(111, 113, 237, 1) 13%, rgba(118, 80, 228, 1) 92%, rgba(118, 78, 228, 1) 96%);
  border: none;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  margin: auto;
}
.khto{
  background-color: rgba(130, 130, 171, 1);
  color: #fff;
}
/deep/ .van-nav-bar .van-icon{
  color: #fff;
}

/deep/ .van-field__control--right{
  font-size: 12px;
  color: #656464;
  font-weight: 400;
}
</style>
